import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input, Select, DatePicker } from "antd";
import Button from "components/button";
import FormItem from "components/fields/FormItem";
import {
  doJobRoleOfferCreate,
  doJobRoleOfferUpdate,
  doGenerteEmploymentAgreement
} from "../../../../redux/jobroleoffer/jobRoleOfferState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import { getLabel } from "utils";
import { DATE_FORMAT } from "variables/constants";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import { displayIcon } from "variables/icons";

const JobRoleOfferForm = ({
  candidate,
  mode='edit',
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const recordData = useSelector((state) => state.jobRoleOffer.jobRoleOfferDetails?.data);

  useEffect(() => {
      if (recordData) {
        form.resetFields();

        const { jof_date_start, ...rest } = recordData;
        const initialValues = {
          ...rest,
          jof_date_start: recordData?.jof_date_start ? dayjs(recordData.jof_date_start) : null,
        };

        form.setFieldsValue(initialValues);
      }
    }, [recordData, candidate, form]);
  
    const onSubmit = (formData) => { 
      try {
        formData.jof_date_start = formData.jof_date_start?.format(DATE_FORMAT);
        formData.jof_salary = parseFloat(formData.jof_salary);
        formData.jof_job_applicant_id = candidate.jap_id;
        formData.jof_client_id = candidate.job_post.jpo_client_id;
        formData.jof_job_role_id = candidate.job_post.jpo_role_request_id;
        formData.no_redirect = true;
        formData.jof_applicant_name = candidate.applicant_name;
  
        recordData?.jof_id > 0 ? dispatch(doJobRoleOfferUpdate(formData)) : dispatch(doJobRoleOfferCreate(formData));
        
      } catch (error) {
        console.error("Save failed:", error);
      }
    };

  return (
    <Form form={form} layout="vertical" className={mode !== "view" ? "form" : ""} onFinish={onSubmit}>
        <FormItem
          name="jof_id"
          hidden
        >
          <Input type="hidden"/>
        </FormItem>
        <FormItem className="font-medium mb-2"
          name="jof_status_id"
          label="Status"
          rules={[requiredField()]}
        >
          {mode !== "view" ?
            <Select id="jof_status_id"
              className="input-field"
              showSearch
              allowClear={true}
              options={recordData?.jobOfferStatusList}
            /> 
            : 
            <label className="text-base label-value dark:text-white">
              {getLabel(recordData?.jobOfferStatusList, recordData?.jof_status_id)}
            </label>
          }              
        </FormItem>
        <div class="grid grid-cols-2 gap-4">
          <FormItem className="font-medium mb-2"
            name="jof_salary"
            label="Salary Offer"
            rules={[ requiredField(),
              {
                pattern: /^\d{1,8}(\.\d{1,2})?$/,
                message: "Enter a valid amount (max 99999999.99, up to 2 decimal places)",
              }
            ]}
          >
            {mode !== "view" ? 
              <Input type="text" 
                id="jof_salary"
                className="input-field"
                maxLength={12}
                placeholder="0.00"
              />
              : 
              <label className="text-base label-value dark:text-white">
                {recordData?.jof_salary}
              </label>
            }
          </FormItem>	
          <FormItem className="font-medium mb-2"
              label="Date Start"
              name="jof_date_start"
              rules={[requiredField()]}
          >
            {mode !== "view" ?
              <DatePicker id="jof_date_start"
                className="input-field"
                format={DATE_FORMAT}
                style={{ width: "100%" }}
              />
            : 
              <label className="text-base label-value dark:text-white">
                {recordData?.jof_date_start}
              </label>
            }
          </FormItem>
        </div>
        
        <FormItem
            className="font-medium mb-2"
            name="jof_remarks"
            label="Remarks"
          >
            <TextArea
              id="jof_remarks"
              className="input-field"
              placeholder="Add remarks"
            />
          </FormItem>

      <div className="w-full flex justify-end">
          <CrudButtons
            mode="edit"
            recordId={0}
            isModal
            modalId="job-role-offer-modal"
            moduleId={0}
            cancelLabel="Close"
          >
            <Button 
              className="crud-button btn-small"
              type="button" 
              onClick={() => dispatch(doGenerteEmploymentAgreement({id: candidate.jap_id}))}
            >
              <div className="flex items-center gap-1">
                {displayIcon('FileText', 'me-1')}
                <span>Generate Contract</span>
              </div>
            </Button>
          </CrudButtons>
      </div>
    </Form>
  );
};


export default JobRoleOfferForm;
